import React from 'react';
import Footer from '@/pages/components/footer/footer.component';

interface Props {
  children: React.ReactNode;
}

const RootLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      {children}
      <Footer />
    </>
  );
};

export default RootLayout;
